import { gql } from '@apollo/client';
import { agencyItemsFragment } from '../fragments/agencyItems';
import { itemsFragment } from '../fragments/items';

export const getInitialItems = gql`
  query InitialItems($limit: Limit!, $offset: Int!) {
    residences(limit: 4, sort: RANDOM) {
      id
      name
      price {
        perSqm
        total {
          minimum
        }
        currency
      }
      address
      shortAddress
      deadline
      coverUrl
      path
      metroName
      companyName
    }
    agencies(first: 16, sort: RANDOM) {
      edges {
        node {
          items(limit: 1, sort: RANDOM) {
            ...agencyItemFields
          }
        }
      }
    }
    featuredItems: items(
      filter: { scope: FEATURED }
      limit: $limit
      offset: $offset
    ) {
      ...itemFields
    }
  }
  ${agencyItemsFragment}
  ${itemsFragment}
`;
